export const SUPPORTED_VARIANT_COLORS = [
    'black',
    'white',
    'transparent',
    'blue',
    'sky blue',
    'navy blue',
    'orange',
    'yellow',
    'gray',
    'grey',
    'navy',
    'purple',
    'red',
    'green',
    'indigo',
    'violet',
    'teal',
    'royal',
    'charcoal',
    'charcoal gray',
    'charcoal grey',
];

const VARIANT_COLOR_DELIMITER = /\s*(?:\/|&|\band\b)\s*/i;

/**
 * Parse a variant color string into one or more color tokens.
 * Supports dual values such as "Black/White", "Black & White", "Black and White",
 * and Foremost dual-color for "Full Color" logo option.
 * @param {string} value
 * @param {{ isLogo?: boolean }} [options]
 * @returns {{ colors: string[], isDual: boolean }}
 */
export function parseVariantColor(value, options = {}) {
    if (value == null || typeof value !== 'string') {
        return { colors: [], isDual: false };
    }

    const trimmed = value.trim();
    if (options.isLogo && trimmed.toLowerCase() === 'full color') {
        return {
            colors: ['foremost-dark-blue', 'foremost-light-blue'],
            isDual: true,
        };
    }

    const colors = trimmed
        .split(VARIANT_COLOR_DELIMITER)
        .map((part) => part.trim().toLowerCase())
        .filter(Boolean);

    return {
        colors,
        isDual: colors.length === 2,
    };
}

/**
 * Convert a color name into a CSS-safe class token.
 * Spaces are preserved so classNames can emit both `.navy.blue` and `.navy-blue` styles.
 * @param {string} name
 * @returns {string}
 */
export function toColorClassName(name) {
    if (name == null || typeof name !== 'string') {
        return '';
    }

    return name.trim().toLowerCase();
}

/**
 * Whether every parsed color part is in the supported list.
 * @param {string} value
 * @param {{ isLogo?: boolean }} [options]
 * @returns {boolean}
 */
export function isSupportedVariantColor(value, options = {}) {
    const { colors } = parseVariantColor(value, options);

    // Only single or dual color values are displayed as swatches.
    if (colors.length === 0 || colors.length > 2) {
        return false;
    }

    return colors.every(
        (color) => SUPPORTED_VARIANT_COLORS.includes(color)
            || color === 'foremost-dark-blue'
            || color === 'foremost-light-blue',
    );
}
